import {axios} from "../../../lib";

export const approveDocument = async (documentId) => {
    return await axios.put(`/documents/${documentId}/status?status=APPROVED`);
};
